import type { HeadingLevel, HeadingLevelSize } from '../MpfInput/MpfInputBaseProps';
import { MpfInputBaseProps, MpfInputEmits } from '../MpfInput/MpfInputBaseProps';

export interface MpfInputDateProps extends Omit<
  MpfInputBaseProps,
  'modelValue' | 'headingLevel' | 'headingLevelSize'
> {
  modelValue?: string;
  legendHeadingLevel?: HeadingLevel;
  legendHeadingSize?: HeadingLevelSize;
  legendFontWeight?: 'bold' | 'normal';
}

export const mpfInputDateDefaults = {
  required: false,
  modelValue: '',
  ariaDescribedby: '',
  legendHeadingLevel: 2 as HeadingLevel,
  legendHeadingSize: 'l' as HeadingLevelSize,
  // @ts-expect-error
  errors: () => [] as string[],
} satisfies Partial<MpfInputDateProps>;

export type MpfInputDateEmits = MpfInputEmits;
